import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = [];

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (_, { payload: { rules = [] } }) =>
      Array.isArray(rules) ? rules : [rules],
  },
  initialState,
);

export const getRulesFilter = state => state;
